define("shared/components/shared/badge", ["exports", "@ember/component", "@ember/template-factory", "@ember/component/template-only"], function (_exports, _component, _templateFactory, _templateOnly) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/component/template-only",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class={{if @className @className "cBL--badge"}}>
    {{#if (has-block "title")}}
      {{yield to="title"}}
    {{else}}
      {{svg-jar 
        "beta-label" 
        class="cBL--badge__title"
        role="img"
        title="Beta Label"
        desc="Beta label icon"
      }}
    {{/if}}
  
    {{#if (has-block "body")}}
      <p class="cBL--badge__desc">
        {{yield to="body"}}
      </p>
    {{else if @href}}
      <Shared::Link
        class="cBL--badge__link"
        @href={{@href}}
        @text={{if @linkText @linkText (t "shared_phrases.learn_more")}}
      />
    {{/if}}
  </div>
  */
  {
    "id": "co9o0p5g",
    "block": "[[[10,0],[15,0,[52,[30,1],[30,1],\"cBL--badge\"]],[12],[1,\"\\n\"],[41,[48,[30,4]],[[[1,\"    \"],[18,4,null],[1,\"\\n\"]],[]],[[[1,\"    \"],[1,[28,[35,3],[\"beta-label\"],[[\"class\",\"role\",\"title\",\"desc\"],[\"cBL--badge__title\",\"img\",\"Beta Label\",\"Beta label icon\"]]]],[1,\"\\n\"]],[]]],[1,\"\\n\"],[41,[48,[30,5]],[[[1,\"    \"],[10,2],[14,0,\"cBL--badge__desc\"],[12],[1,\"\\n      \"],[18,5,null],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],[[[41,[30,2],[[[1,\"    \"],[8,[39,4],[[24,0,\"cBL--badge__link\"]],[[\"@href\",\"@text\"],[[30,2],[52,[30,3],[30,3],[28,[37,5],[\"shared_phrases.learn_more\"],null]]]],null],[1,\"\\n  \"]],[]],null]],[]]],[13]],[\"@className\",\"@href\",\"@linkText\",\"&title\",\"&body\"],false,[\"if\",\"has-block\",\"yield\",\"svg-jar\",\"shared/link\",\"t\"]]",
    "moduleName": "shared/components/shared/badge.hbs",
    "isStrictMode": false
  });

  var _default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());

  _exports.default = _default;
});